import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import './index.css'; // Your CSS file for styling

const AudioPlayer = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef();

  useEffect(() => {
    const audioElement = audioRef.current;
    const updateTime = () => {
      setProgress((audioElement.currentTime / audioElement.duration) * 100);
    };
    audioElement.addEventListener('timeupdate', updateTime);
    return () => {
      audioElement.removeEventListener('timeupdate', updateTime);
    };
  }, []);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="">
      <audio
        ref={audioRef}
        src={src}
        onLoadedMetadata={() => setDuration(audioRef.current.duration)}
        onEnded={() => setIsPlaying(false)}
      />
      <div className="flex items-center justify-between gap-3 px-1  w-full">
        <div onClick={togglePlay}  width={30} height={30} className='w-[30px] h-[30px] cursor-pointer flex items-center justify-center rounded-full bg-[#1CA571] text-white p-2'>
            
          {isPlaying ? (
            <FontAwesomeIcon icon={faPause} size='sm' className='w-full height-full'/>
          ) : (
            <FontAwesomeIcon icon={faPlay} size='sm'  className='w-full height-full' />
          )}
        </div>
        <div className="progress-bar flex-1">
          <div className="progress-line" style={{ width: `${progress}%` }} />
          <div className="progress-circle" style={{ left: `${progress}%` }} />
        </div>
        <span className="progress-time">
          {formatTime(audioRef.current?.currentTime)}/{formatTime(duration)}
        </span>
      </div>
    </div>
  );
};

export default AudioPlayer;
